export default __webpack_public_path__ + "static/media/variant-switcher-plugin.333722bb.svg";